export default __webpack_public_path__ + "static/media/048-road sign.4885def5.svg";